import React, { useState, useEffect, useCallback, Fragment, memo } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import  {             
            Button,
            Checkbox,
            Chip,
            Dialog,
            DialogActions,
            DialogContent,
            DialogTitle,
            Fab,
            FormControlLabel,
            Grid,
            Grow,
            IconButton,
            LinearProgress,
            Menu,
            MenuItem,
            Paper,
            Slider,
            Switch,          
            TableBody,
            TableHead,
            TablePagination,
            TableSortLabel,
            TableRow,
            TextField,
            Tooltip,
            withWidth
} from '@material-ui/core';
import { 
            Add as AddIcon,
            Autorenew as AutorenewIcon,
            BorderVertical as BorderVerticalIcon,
            Brush as BrushIcon,
            Cancel as CancelIcon,
            CheckBox as CheckBoxIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            Clear as ClearIcon,
            DateRange as DateRangeIcon,
            Delete as DeleteIcon,
            Description as DescriptionIcon,
            Edit as EditIcon,
            FilterList as FilterListIcon,
            MarkunreadMailbox as MarkunreadMailboxIcon,
            MoreVert as MoreVertIcon,
            NavigateNext as NavigateNextIcon,
            OfflinePin as OfflinePinIcon,
            PictureAsPdf as PictureAsPdfIcon,
            PlusOne as PlusOneIcon,
            RestoreFromTrash as RestoreFromTrashIcon,
            Save as SaveIcon,
            Search as SearchIcon,
            Visibility as VisibilityIcon,
            ViewWeek as ViewWeekIcon,
} from '@material-ui/icons';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import { 
    Modal as ModalAntd,
    Switch as SwitchAntd, 
} from 'antd';
import Swal from 'sweetalert2';
import PdfElement from '../Elementos/PdfElement';
import ExcelComponent from '../Elementos/ExcelComponent';
import {
    TableContainerYounet,
    TableYounet,
    TheadYounetStyledFixed,
    TheadYounetStyled,
} from '../Elementos/TablaContainerYounet';

    const onlyStatus = [
        'En Garantia',
        'No Disponible'
    ];

    const useStyles = makeStyles((theme) => ({
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
            color:'#fff'
        },
    }));

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Grow direction="up" ref={ref} {...props} timeout={750} />;
    });

    const TdYounetStyledFixed = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '10px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:#ffffff;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:6px; 
        position:sticky;
        z-index:1; 
        left:${props => props.left || '0px'};
        text-overflow: ellipsis; 
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const TdYounetStyled = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '10px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.paddingTop ? props.paddingTop : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:transparent;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:${props => props.isMultiline ? 'auto' : '43px'};
        max-height:${props => props.isMultiline ? 'auto' : '43px'};
        padding:${props => props.padding ? props.padding : '10px'};   
        position:relative;
        left:0px;      
        text-overflow: ellipsis;    
        white-space:${props => props.isMultiline ? 'pre-wrap' : 'nowrap'} ;  
        overflow:${props => props.isMultiline ? 'auto' : 'hidden'};
    `;

    const TrYounetStyled = styled.tr`
        display:flex;
        position:'sticky';
        top:0px;
        z-index:2;
        background-color:${props => props.selected ? 'LightBlue' : '#fff'};
        &:hover{
            background-color:Gainsboro
        }
    `;

    const headCellsColumn = [
        { id: 'Tipo', numeric: false, disablePadding: false, label: 'Tipo', show:true, fixed:false, width:160, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Marca', numeric: false, disablePadding: false, label: 'Marca', show:true, fixed:false, width:200, num:1, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Modelo', numeric: false, disablePadding: false, label: 'Modelo', show:true, fixed:false, width:200, num:2, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Bridge', numeric: false, disablePadding: false, label: 'Bridge', show:true, fixed:false, width:120, num:3, align:'left', fontSize:'16px', bolder:false , type:'switch'    },
        { id: 'Tecnologia', numeric: false, disablePadding: false, label: 'Tecnologia', show:true, fixed:false, width:200, num:4, align:'left', fontSize:'16px', bolder:false , type:'select'    },
        { id: 'Mac', numeric: false, disablePadding: false, label: 'Mac', show:true, fixed:false, width:250, num:5, align:'left', fontSize:'16px', bolder:false , type:'mac'    },
        { id: 'Mac2', numeric: false, disablePadding: false, label: 'Mac2', show:true, fixed:false, width:250, num:6, align:'left', fontSize:'16px', bolder:false , type:'mac'    },
        { id: 'SN', numeric: false, disablePadding: false, label: 'SN', show:true, fixed:false, width:250, num:7, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Proveedor', numeric: false, disablePadding: false, label: 'Proveedor', show:true, fixed:false, width:200, num:8, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Status', numeric: false, disablePadding: false, label: 'Status', show:true, fixed:false, width:150, num:9, align:'center', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'idForMikrotik', numeric: false, disablePadding: false, label: 'ID', show:true, fixed:false, width:150, num:10, align:'center', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Observacion', numeric: false, disablePadding: false, label: 'Observacion', show:true, fixed:false, width:250, num:11, align:'center', fontSize:'14px', bolder:false , type:'text'    },
        { id: 'fechaCompra', numeric: false, disablePadding: false, label: 'Fecha Compra', show:true, fixed:false, width:150, num:12, align:'center', fontSize:'16px', bolder:false , type:'date'    },
        { id: 'Modificacion', numeric: false, disablePadding: false, label: 'Modificacion', show:true, fixed:false, width:250, num:13, align:'center', fontSize:'16px', bolder:false , type:'date'    },
    ];

    const variablesObject = {
        title:'STOCKS',
        nameLocalStorage:'headersStockAlmaAC',
        api:'/api/Stocks',
        label:'STOCK',
        sumWidth:'100%',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
    };

    const propsWidth = { general:100 };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
    };
      
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };
      
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const TheadYounetFixed = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, headCells, align})=>{
        const [ leftValue, setLeftValue ] = useState('0px')
        
        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setLeftValue(`${numero}px`)
            }
            
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        return(
            <TheadYounetStyledFixed width={widthDefault} left={leftValue} align={align}>
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)} 
                    style={{color:'#fff', textAlign:align}}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                </TableSortLabel>
            </TheadYounetStyledFixed>
        );
    });

    const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
        <TheadYounetStyled width={widthDefault} align={align}>
            <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)} 
                style={{color:'#fff', textAlign:align}}
            >
                {headCell.label}
                {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
            </TableSortLabel>
        </TheadYounetStyled>
    ));

    const TdYounet = memo(((props)=>{
        const { minWidth, width, headCells, headCell, valueInfo, fixed, align, bolder, fontSize, idCell } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Disponible'? 'green' : valueInfo === 'En Garantia' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Disponible'? 'green' : valueInfo === 'En Garantia' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyled>
            }
            </Fragment>
        )
        
        
    }));

    const TdYounetSwitch = memo(((props)=>{
        const { minWidth, width, headCells, headCell, valueInfo, fixed, align, bolder, fontSize, idCell } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Disponible'? 'green' : valueInfo === 'En Garantia' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo ? 'SI' : 'NO'}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Disponible'? 'green' : valueInfo === 'En Garantia' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo ? 'SI' : 'NO'}
                </TdYounetStyled>
            }
            </Fragment>
        )
        
        
    }));

    function EnhancedTableHead(props) {
        
        const { classes, order, orderBy, onRequestSort, headCells, HandleChangeWidth } = props;

        const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
        };
    
        return (
            <TableHead style={{position:'sticky', top:0, zIndex:2}}>
                <TableRow style={{display:'flex'}} >
                    <TheadYounetStyled width={180} align='left'>
                        ACTIONS
                    </TheadYounetStyled>
                {headCells.map( headCell =>  
                    headCell.show && ( 
                        headCell.fixed 
                        ? 
                        <TheadYounetFixed  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth} 
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                            
                            />
                        : 
                        <TheadYounet  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth}
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                         />
                        
                ))}
                </TableRow>
            </TableHead>
        );
    };
    
    const FiltradoEl = ({ index, info, HandleAddFilter, HandleDeleteFilter, HandleAddInformacionFilter, headersColumn})=>{
        const [ elementValue, setElementValue ] = useState({ idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'O', type:''});

        useEffect(()=>{
            setElementValue({ idElement:info.idElement, valorElement:info.valorElement, numero:index, labelElement:info.labelElement, selectElement:info.selectElement, type:info.type})
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const HandleElementValue = (e)=>{
            setElementValue({...elementValue, valorElement:e.target.value});
           // HandleAddInformacionFilter(index, e.target.id, e.target.value)
        };

        const HandlePreDeleteFilter = ()=>{
            HandleDeleteFilter(index);
        };

        const HandlePreAddInfFilter = (e)=>{
            HandleAddInformacionFilter(elementValue)
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementValue({...elementValue, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementValue({...elementValue, idElement:arrFilHeaders[0].id.toString(), labelElement:value, type:arrFilHeaders[0].type.toString()});
                }
                
            }
            
        };

        const HandleSelectElement = (e)=>{
            setElementValue({...elementValue, selectElement:e.target.value});
        };

        const handleDatosMac = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if(val.length > 6){
                alert('LIMITE DE CARACTERES EXCEDIDO');
            }else{
                setElementValue({...elementValue, valorElement:val !== null ? val.join(":") : val});
            }
            
        };

        if(index === 0){
            return( 
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}  key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />: elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />: elementValue.type === 'mac' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleDatosMac}
                                    maxlength="6"
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}     
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                        </Grid>
                        <Grid item xl={1} lg={2} md={2} sm={2} xs={2}>
                            <IconButton style={{marginTop:5}} onClick={HandleAddFilter}>
                                <AddIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }else{ 
            return(
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />:elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />: elementValue.type === 'mac' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleDatosMac}
                                    maxlength="6"
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter} 
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                            
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2} >
                            <TextField
                                id={`selectElement-${index}`}
                                select
                                value={elementValue.selectElement || ''}
                                onChange={HandleSelectElement}
                                style={{marginTop:8}}
                                onBlur={HandlePreAddInfFilter}
                            >
                                <MenuItem value={'O'}>O</MenuItem>
                                <MenuItem value={'Y'}>Y</MenuItem>
                            </TextField>
                            <IconButton onClick={HandlePreDeleteFilter} style={{marginTop:5}} id={`bu-${index}`}>
                                <DeleteIcon style={{color:'red'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>                                
            )
        }
    };

    const Roow = memo((props)=>{
        const { 
            row, 
            index, 
            headCells, 
            handleClickRow, 
            // dispatch, 
            Equipos, 
            Proveedores, 
            getTecnologias,
            getArrMac, 
            enqueueSnackbar, 
            onlyTipos, 
            selectionArr ,
            handleEditRow,
            handleDeleteRow
        } = props;
        const [ statusRow, setStatusRow ] = useState(false);
        const [ continuoStatus, setContinuoStatus ] = useState(false);
        const [ dataRow, setDataRow ] = useState({});
        const [ arrMarcas, setArrMarcas ] = useState([]);
        const [ arrModelos, setArrModelos ] = useState([]);
        const [ openEdit, setOpenEdit ] = useState(false);
        const [ getOnSave, setOnSave ] = useState(false);

        useEffect(()=>{
            const arr = [...selectionArr];
            const arrMap = arr.filter(el=>el._id === row._id);
            arrMap.length > 0 && setStatusRow(true);
        },[]);  // eslint-disable-line react-hooks/exhaustive-deps


        useEffect(()=>{
            if(continuoStatus){
                setContinuoStatus(false);
                if(statusRow){
                    handleClickRow(statusRow, row)
                }else{
                    handleClickRow(statusRow, row)
                }
            }
        },[continuoStatus]); // eslint-disable-line react-hooks/exhaustive-deps

    
        const handleDelete = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR ESTE ${variablesObject.label}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if(result.isConfirmed){
                    fetch(variablesObject.api,{ method:'DELETE', body: JSON.stringify(row), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            // dispatch({type:types.stockDelete, payload:row});
                            handleDeleteRow(row._id);
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true
                            })
                        }
                        
                    })
                }

            })
            
        };

        const HeadCellArr = headCells.map((value, index2)=>( 
            <Fragment key={`${index}_${index2}_${row._id}`} >
                { value.show &&
                    <Fragment>
                    {
                        value.type === 'switch' ?
                        <TdYounetSwitch
                            key={`${index}_${index2}_${row._id}_Td`}
                            width={value.width} 
                            minWidth={propsWidth.general} 
                            headCells={headCells} 
                            headCell={value} 
                            idCell={value.id}
                            valueInfo={row[value.id]}
                            fixed={value.fixed}
                            align={value.align}
                            fontSize={value.fontSize}
                            bolder={value.bolder}
                        />:
                        <TdYounet 
                            key={`${index}_${index2}_${row._id}_Td`}
                            width={value.width} 
                            minWidth={propsWidth.general} 
                            headCells={headCells} 
                            headCell={value} 
                            idCell={value.id}
                            valueInfo={row[value.id]}
                            fixed={value.fixed}
                            align={value.align}
                            fontSize={value.fontSize}
                            bolder={value.bolder}
                        />
                    }
                    </Fragment>
                }
            </Fragment>
        ));

        const HandlePreClickRow = ()=>{
            setStatusRow(!statusRow);
            setContinuoStatus(true);
        };

        const handleTipos = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow,Tipo:value, Marca:'', Modelo:'', Mac:'', SN:''});
                const tipoFilter = Equipos.filter(elEquipo=> elEquipo.Tipo === value);
                const arrNew = tipoFilter.map(elEqui=>elEqui.Marca);
                const newSet = new Set(arrNew);
                const arrSet = [...newSet];
                setArrMarcas(arrSet);
            }else{
                setDataRow({...dataRow, Tipo:'', Marca:'', Modelo:'', Mac:'', SN:''});
                setArrMarcas([]);
                setArrModelos([]);
            }
        };

        const handleMarcas = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Marca:value, Modelo:'', Mac:'', SN:''});      
                const tipoFilter = Equipos.filter(elEquipo=> elEquipo.Tipo === dataRow.Tipo);
                const marcaFilter = tipoFilter.filter(elEquipo=> elEquipo.Marca === value);        
                const arrNew = marcaFilter.map(elEqui=>elEqui.Modelo);
                const newSet = new Set(arrNew);
                const arrSet = [...newSet];
                setArrModelos(arrSet);
            }else{
                setDataRow({...dataRow, Marca:'', Modelo:'', Mac:'', SN:''});
                setArrModelos([]);
            }
        };

        const handleModelos = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Modelo:value, Mac:'', SN:''});
            }else{
                setDataRow({...dataRow, Modelo:'', Mac:'', SN:''});
            }
        };

        const handleProveedores = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Proveedor:value});
            }else{
                setDataRow({...dataRow, Proveedor:''});
            }
        };

        const handleTecnologias = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Tecnologia:value});
            }else{
                setDataRow({...dataRow, Tecnologia:''});
            }
        };

        const handleBridge = (checked)=>{ setDataRow({...dataRow, Bridge:checked}); }

        const handleDatosMac = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if( getArrMac.includes(val !== null ? val.join(":") : val)){
                alert('YA EXISTE UNA MAC IGUAL')
            }else{
                if(val.length > 6){
                    enqueueSnackbar('LIMITE DE CARACTERES EXCEDIDO', {variant:'error'})
                }else{
                    setDataRow({...dataRow, Mac:val !== null ? val.join(":") : val });
                }
            }
        };

        const handleDatosMac2 = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if( getArrMac.includes(val !== null ? val.join(":") : val)){
                alert('YA EXISTE UNA MAC IGUAL')
            }else{
                if(val.length > 6){
                    enqueueSnackbar('LIMITE DE CARACTERES EXCEDIDO', {variant:'error'})
                }else{
                    setDataRow({...dataRow, Mac2:val !== null ? val.join(":") : val });
                }
            }
        };
        
        const handleOption = ({target})=>{ setDataRow({...dataRow, [target.name]:target.value}); }

        const handleCancelar = ()=>{ setOpenEdit(false); };

        const handleOpenEdit = ()=>{
            setDataRow(row)
            setOpenEdit(true);
        };

        const handleSave = ()=>{
            setOnSave(true);
            if(row.Status === 'No Disponible'){
                enqueueSnackbar('ESTE EQUIPO YA FUE ASIGNADO A UN CLIENTE NO SE PUEDE EDITAR', {variant:'error'});
                setOnSave(false);
            }else{
                if(dataRow.Mac.length < 17){
                    enqueueSnackbar('ERROR MAC', {variant:'error'});
                    setOnSave(false);
                }else{
                    fetch(variablesObject.api,{ method:'PUT', body: JSON.stringify(dataRow), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            // dispatch({type:types.stockUpdate, payload:result.data});
                            handleEditRow(dataRow._id, result.data)
                            enqueueSnackbar(result.message, {variant:'success'});
                            setTimeout(()=>{
                                setOnSave(false);
                            },1000)
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596'
                            })
                        }                   
                    })
                }
                
            }
            
        };

        const handleValidarActivar = ()=>{
            const objetoNew = {...row};
            objetoNew.StatusAct = 'Disponible';
            Swal.fire({
                title: 'DESEA PROCEDER?',
                icon:'info',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor:'#005596'
            }).then((result_) => {
                if(result_.isConfirmed){
                    fetch('/api/Stocks/Activar',{ 
                        method:'POST', 
                        body: JSON.stringify(objetoNew), 
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            handleEditRow(row._id, objetoNew)
                            Swal.fire({
                                title: result.message,
                                icon:'success',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596'
                            })
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596'
                            })
                        }
                        
                    })
                }

            })
        };

        return(
            <Fragment>
                <ModalAntd title="EDICION" visible={openEdit} onOk={handleSave} onCancel={handleCancelar}  confirmLoading={getOnSave} destroyOnClose>
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                        <Grid container justifyContent='space-between' spacing={2}> 
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`${row._id}_Tipo`}
                                    options={onlyTipos}
                                    value={dataRow.Tipo || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Tipo' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleTipos} 
                                    size='small'                                 
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`${row._id}_Marca`}
                                    options={arrMarcas}
                                    value={dataRow.Marca || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Marca' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleMarcas} 
                                    size='small'  
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`${row._id}_Modelo`}
                                    options={arrModelos}
                                    value={dataRow.Modelo || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Modelo' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleModelos} 
                                    size='small' 
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                     id={`${row._id}_Tecnologias`}
                                    options={getTecnologias}
                                    value={dataRow.Tecnologia || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Tecnologia' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleTecnologias} 
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`${row._id}_Mac`}
                                    fullWidth
                                    label='Mac'
                                    value={dataRow.Mac || ''}
                                    onChange={handleDatosMac}
                                    maxlength="6"
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`${row._id}_Mac2`}
                                    fullWidth
                                    label='Mac2'
                                    value={dataRow.Mac2 || ''}
                                    onChange={handleDatosMac2}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField 
                                    id={`${row._id}_SN`}
                                    name='SN'
                                    fullWidth
                                    label='SN'
                                    value={dataRow.SN || ''}
                                    onChange={handleOption}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={4} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <SwitchAntd checkedChildren="BRIDGE" unCheckedChildren="NO BRIDGE" checked={dataRow.Bridge} onChange={handleBridge} /> 
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`${row._id}_Proveedor`}
                                    options={Proveedores.map(elProv=>elProv.Nombre)}
                                    value={dataRow.Proveedor || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Proveedor' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleProveedores} 
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`${row._id}_Status`}
                                    fullWidth
                                    label='Status'
                                    value={dataRow.Status || ''}
                                    variant='outlined'
                                    size='small'

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`${row._id}_idMikrotik`}
                                    fullWidth
                                    label='idMikrotik'
                                    value={dataRow.idForMikrotik || ''}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`${row._id}_fechaCompra`}
                                    name='fechaCompra'
                                    fullWidth
                                    label='Fecha Compra'
                                    value={dataRow.fechaCompra || '2022-01-01'}
                                    onChange={handleOption}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    type='date'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    id={`${row._id}_Obs`}
                                    name='Observacion'
                                    fullWidth
                                    label='Observacion'
                                    value={dataRow.Observacion || ''}
                                    onChange={handleOption}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    multiline
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </ModalAntd> 
                <TrYounetStyled key={`fila-${row._id}`}  selected={statusRow} >
                    <TdYounetStyled minWidth={180} width={180}>
                        <Grid container spacing={1} style={{height:32, marginTop:-10}}>
                            <Grid item >
                                <Checkbox
                                    checked={statusRow}
                                    color='primary'
                                    onClick={HandlePreClickRow}
                                    style={{marginTop:-4}}
                                    size='small'
                                />
                            </Grid>
                            <Grid item>
                                <Tooltip title={`EDITAR`} placement='top' arrow>
                                    <span>
                                    <IconButton color='primary' onClick={handleOpenEdit} size='small'>
                                        <EditIcon/>
                                    </IconButton>
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item >
                                <Tooltip title={`ELIMINAR`} placement='top' arrow>
                                    <span>
                                        <IconButton aria-label="expand row" size="small" onClick={handleDelete} color='primary'>
                                            <DeleteIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Grid>  
                           { row.Status !== "Disponible" && 
                                <Grid item >
                                    <Tooltip title={`ACTIVAR`} placement='top' arrow>
                                        <span>
                                            <IconButton aria-label="expand row" size="small" onClick={handleValidarActivar} color='primary'>
                                                <OfflinePinIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                            }
                        </Grid>
                    </TdYounetStyled>
                    { HeadCellArr }
                </TrYounetStyled>
            </Fragment>
        );
    });

    const RowHeadersStyle = memo(({rowInfo, HandleProcessHeaders, widthWin})=>{

        const { id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type } = rowInfo;
        const [ infoRow, setInfoRow ] = useState({ id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type });

        const HandleInformacion = (e)=>{
            setInfoRow({...infoRow, [e.target.name]:e.target.value})
        };

        const HandleSwitch = (e)=>{
            setInfoRow({...infoRow, bolder:e.target.checked})
        };

        const HandleProcess = ()=>{
            HandleProcessHeaders(infoRow);
        };

        const handleChangeWidth = (e, value)=>{
            setInfoRow({...infoRow, width:value})
        };

        const HandleReset = ()=>{
            const element = headCellsColumn.filter(value=> value.id === rowInfo.id)[0];
            HandleProcessHeaders(element);
        };

        return(
            <Paper elevation={2} style={{width:'100%', padding:10}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                    <Grid container spacing={2} style={{minHeight:40}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xs={3}>
                                        <Tooltip  title='GUARDAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcess} >
                                                <SaveIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Tooltip  title='RESET' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleReset} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'style={{marginTop:5}}/>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleProcess} endIcon={<SaveIcon/>}> GUARDAR </Button> 
                                    </Grid>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleReset} endIcon={<AutorenewIcon/>}> RESET </Button> 
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'/>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'align'}
                            value={infoRow.align ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Alinear Texto'
                            select
                        >
                            <MenuItem  value={'left'}>
                                IZQUIERDA
                            </MenuItem>
                            <MenuItem  value={'center'}>
                                CENTRADO
                            </MenuItem>
                            <MenuItem  value={'right'}>
                                DERECHA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'fontSize'}
                            value={infoRow.fontSize ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Tamaño Texto'
                        />
                    </Grid>
                    <Grid item style={{width:100}}>
                        <Slider 
                            value={infoRow.width} 
                            onChange={handleChangeWidth} 
                            aria-labelledby="continuous-slider" 
                            step={5}
                            min={50}
                            max={600}
                        />
                        <p>Ancho:{infoRow.width}</p>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                            <Switch
                                checked={infoRow.bolder}
                                onChange={HandleSwitch}
                                id={`${rowInfo.id}_${rowInfo.label}`}
                                color="primary"
                            />
                            }
                            label={'Negritas'}
                        />
                    </Grid>
                </Grid>
            </Paper>
        );      
    });

    const Elemento = ({widthWin})=>{
        const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
        const checkedIcon = <CheckBoxIcon fontSize="small" />;
        const classes = useStyles();
        const { setOpen, authTokens, setRuta } = useAuth();
        const { enqueueSnackbar } = useSnackbar();
        const [ rows, setRows ] = useState([]);
        const [ backupRows, setBackupRows ] = useState([]);
        const [ order, setOrder] = useState('desc'); 
        const [ orderBy, setOrderBy] = useState('Modificacion');
        const [ page, setPage] = useState(0);
        const [ rowsPerPage, setRowsPerPage] = useState(widthWin === 'xs' ? 10 : 14);
        const [ headersColumn, setHeadersColumn ] = useState(()=>{
            try{
                if(window.localStorage.getItem(variablesObject.nameLocalStorage)){
                    const headersStorage = window.localStorage.getItem(variablesObject.nameLocalStorage) ;
                    const headersParse = JSON.parse(headersStorage);
                    return headersParse
                }else{
                    return headCellsColumn
                }
            }catch(err){
                console.log(err);
                return headCellsColumn
            }
        });
        const [ openMenuColumn, setOpenMenuColumn ] = useState(null);
        const [ openMenuColumnFixed, setOpenMenuColumnFixed ] = useState(null);
        const [ isSavingHeaders, setSavingHeaders ] = useState(false);
        const [ openMenuFilter, setOpenMenuFilter ] = useState(false);
        const [ openMenuDate, setOpenMenuDate ] = useState(null);
        const [ openMenuPdf, setOpenMenuPdf ] = useState(null);
        const [ openMenuExcel, setOpenMenuExcel ] = useState(null);
        const [ openMenuStyles, setOpenMenuStyles ] = useState(false);
        const [ openMenuPosicion, setOpenMenuPosicion ] = useState(false);
        const [ arrFiltrado, setArrFiltrado ] = useState([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
        const [ elementDate, setElementDate ] = useState({ idElement:'', labelElement:'', Inicio:'', Final:''});
        const [ isFilterDate, setFilterDate ] = useState(false);
        const [ isFilterNow, setFilterNow ] = useState(false);
        const [ isElementFilterShow, setElementFilterShow ] = useState(true);
        const [ rowsFilter, setRowsFilter ] = useState([]);
        const [ rowsFilterDate, setRowsFilterDate ] = useState([]);
        const [ selectionArr, setSelectionArr ] = useState([]);
        const [ isReadyPdf, setReadyPdf ] = useState(false);
        const [ isSelectPdf, setSelectPdf ] = useState(false);
        const [ isContinuoPdf, setContinuoPdf ] = useState(false);
        const [ arrHeadersPdf, setArrHeadersPdf ]= useState([])
        const [ openSelectPersonsMail, setOpenSelectPersonsMail ] = useState(false);
        const [ Remitentes, setRemitentes ] = useState([]);
        const [ RemitentesAll, setRemitentesAll ] = useState([]);
        const [ isCharging, setCharging ] = useState(true);
        const [ Equipos, setEquipos ] = useState([])
        const [ Proveedores, setProveedores ] = useState([]);
        const [ openDanado, setOpenDanado ] = useState(false);
        const [ openActivar, setOpenActivar ] = useState(false);
        const [ ReporteDanado, setReporteDanado ] = useState({
            Marca:'',
            Modelo:'', 
            Mac:'', 
            Macs:[],
            Observacion:'', 
            StatusAct:'',
            Tipo:'', 
        });
        const [ onlyTipos, setOnlyTipos ] = useState([]);
        const [ onlyMarcas, setOnlyMarcas ] = useState([]);
        const [ onlyModelos, setOnlyModelos ] = useState([]);
        const [ onlyMacs, setOnlyMacs] = useState([]);
        const [ onlyMacsDanadas, setOnlyMacsDanadas ] = useState([]);
        const [ getArrMac, setArrMac ] = useState([]);
        const [ getTecnologias, setTecnologias ] = useState([]);
        const [ dataRow, setDataRow ] = useState({
            Tipo:'', Marca:'', Modelo:'', 
            Bridge:false, Tecnologia:'', 
            Mac:'', Mac2:'', Proveedor:'', 
            SN:'', Status:'Disponible', 
            idForMikrotik:'', Observacion:'',
            fechaCompra:'', idForMikrotikBack:'',
            Danado:false, fechaDanado:'', NumSerie:''
        });
        const [ getOpenNew, setOpenNew ] = useState(false);
        const [ getOnSave, setOnSave ] = useState(false);
        const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
        const [ getSearch, setSearch ] = useState('');
        const [ getOptionSearch, setOptionSearch ] = useState('Mac');
        const [ getContinuoUnSelect, setContinuoUnSelect ] = useState(false);
        const [ isShowBusqueda, setShowBusqueda ] = useState(true);
        const [ getElementD, setElementD ] = useState(0);
        const [ isDelete, setDelete ] = useState(false);
        const [ isContinuoMac, setContinuoMac ] = useState(false);
        const [ numberMac, setNumberMac ] = useState(0);

        useEffect(()=>{
            const handleUseEffect = async ()=>{
                if(widthWin === 'xs') setShowBusqueda(true);
                setRuta('/Almacen/Stock');
                setOpen(false); 
                const dataUser = await fetch('/api/users');
                const infoUser = await dataUser.json();
                const arrMails = infoUser.map(elUser=> elUser.Mail);
                const dataEqui = await fetch('/api/EquiposAls');
                const infoEqui =  await dataEqui.json();
                const dataProv = await fetch('/api/Proveedores');
                const infoProv =  await dataProv.json();
                const dataProv1 = await fetch('/api/Tecnologias');
                const infoProv1 =  await dataProv1.json();
                const dataStock = await fetch('/api/Stocks');
                const infoStock =  await dataStock.json();
                const dataTipos = await fetch('/api/Tipos');
                const infoTipos =  await dataTipos.json();
                setRows(infoStock);
                setBackupRows(infoStock);
                const infoProv2 = infoProv1.map(el=> el.Tecnologia);
                setProveedores(infoProv);
                setEquipos(infoEqui);
                setRemitentesAll(arrMails);
                setTecnologias(infoProv2);
                setOnlyTipos(infoTipos.map(el=>el.Tipo));
                const macArr = infoStock.map(el=>el.Mac && el.Mac.toString().trim().toUpperCase());
                setArrMac(macArr);
                setCharging(false);
            };
            
            handleUseEffect();

        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(isContinuoPdf){
                setContinuoPdf(false);
                setReadyPdf(true);
            }
        },[isContinuoPdf]); // eslint-disable-line react-hooks/exhaustive-deps
        
        useEffect(()=>{
            if(getContinuoUnSelect){
                setContinuoUnSelect(false);
                setRows(backupRows);
            }
        },[getContinuoUnSelect, backupRows])

        useEffect(()=>{
            if(isDelete){ 
                setDelete(false);
                handleDeleteElement();
            }
        },[isDelete]) // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(isContinuoMac){
                setContinuoMac(false);
                handleProcesarDanado();
            }
        },[isContinuoMac]) // eslint-disable-line react-hooks/exhaustive-deps

        const handleClickMenu = (event) => { setOpenMenuColumn(event.currentTarget);};

        const handleClickMenuFixed = (event) => { setOpenMenuColumnFixed(event.currentTarget);};

        const handleClickMenuFilter = (event) => {
            setOpenMenuFilter(true);
            setElementFilterShow(true);
        };

        const handleClickMenuDate = (event) => { setOpenMenuDate(event.currentTarget);};

        const handleClickMenuPdf = (event) => { setOpenMenuPdf(event.currentTarget);};

        const handleClickMenuExcel = (event) => {setOpenMenuExcel(event.currentTarget);};

        const handleCloseMenu = () => {setOpenMenuColumn(null)};

        const handleCloseMenuFixed = () => { setOpenMenuColumnFixed(null) };

        const handleCloseMenuFilter = () => {
            setOpenMenuFilter(false);
            setElementFilterShow(false);
        };

        const handleCloseMenuDate = () => { setOpenMenuDate(null) };

        const handleCloseMenuPdf = ()=> { setOpenMenuPdf(null) };

        const handleCloseMenuExcel = ()=> { setOpenMenuExcel(null) };

        const handleRequestSort = useCallback((event, property) => {
            const isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },[order, orderBy])
            
        const handleChangePage = (event, newPage) => { setPage(newPage) };
        
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const HandleChangeSwitch = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.show = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
        };
        
        const ElementMenu = headersColumn.map((value,index)=>{
            return(
                <MenuItem key={`ElementMenu-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.show}
                            onChange={HandleChangeSwitch}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
            )
            
        });

        const HandleChangeSwitchFixed = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.fixed = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
            setSavingHeaders(true);
            setOpenMenuColumnFixed(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000)
        };

        const ElementMenuFixed = headersColumn.map((value,index)=>( 
                <MenuItem key={`ElementMenuFixed-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.fixed}
                            onChange={HandleChangeSwitchFixed}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
        ));

        const HandleAddInformacionFilter = useCallback((objeto)=>{
            const arrF = arrFiltrado.map((value,index)=> {
                if(objeto.numero === index){
                    return objeto
                }else{
                    return value
                }
            })
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleDeleteFilter = useCallback((infElement)=>{ 
            const arrF = arrFiltrado.filter((value,index)=> infElement !== index);
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleAddFilter = useCallback(()=>{
            const cant = arrFiltrado.length;
            setArrFiltrado([...arrFiltrado, {numero:cant, valueElement:'', idElement:'', labelElement:'', selectElement:'O'} ]);
        },[arrFiltrado]);

        const ElementMenuFilter = arrFiltrado.map((value,index)=>
            <FiltradoEl 
                key={`filterElement-${index}`} 
                index={index} 
                info={value} 
                HandleAddFilter={HandleAddFilter} 
                HandleDeleteFilter={HandleDeleteFilter}
                HandleAddInformacionFilter={HandleAddInformacionFilter}
                headersColumn={headersColumn}
        />);

        const HandleProcessFilterElement = ()=>{
            const arrInfo = [...rows];
            if(isFilterNow){
                console.log('isFilterNow');
                let dataNow = [ ];
                arrFiltrado.forEach((value,index)=>{
                    if(index === 0){
                        if(value.type === 'number'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                            });
                        }else if(value.type === 'text'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                            });
                        }else{
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                            });
                        }
                    }else{
                        if(value.type === 'number'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                );
                            }
                        }else if(value.type === 'text'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                );
                            }          
                        }else{
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString())
                                );
                            }
                                
                        }
                    }
                }); 
                let hash = {};
                dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                setRows(dataNow);
                setRowsFilter(dataNow);
            }else{
                console.log('!isFilterNow');
                if(arrFiltrado[0].valorElement === ''){
                    setOpenMenuFilter(false);
                    setTimeout(()=>{
                        Swal.fire({
                            title:'NO HAY ELEMENTOS QUE FILTRAR',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                        });
                    },200);
                    
                }else{
                    let dataNow = [ ];
                    arrFiltrado.forEach((value,index)=>{
                        if(index === 0){
                            console.log('index0');
                            if(value.type === 'number'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                });
                            }else if(value.type === 'text'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))){ 
                                        dataNow.push(value2);
                                        console.log(value2);
                                    }
                                });
                            }else{
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                                });
                            }
                        }else{
                            console.log('!index0');
                            if(value.type === 'number'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                    );
                                }
                            }else if(value.idElement === 'text'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                    );
                                } 
                            }else{
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase())
                                    );
                                }  
                            }
                        }
                    }); 
                    let hash = {};
                    dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                    setFilterNow(true);
                    setRows(dataNow);
                    setRowsFilter(dataNow);
                }
            }
        };

        const HandleResetFilter = ()=>{
            setElementFilterShow(false);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}])
            setFilterNow(false);
            if(isFilterDate){
                setRows(rowsFilterDate);
            }else{
                setRows(backupRows);
            }
            setTimeout(()=>{
                setElementFilterShow(true);
            },1000)
        };

        const HandleMenuDate = (e)=>{ setElementDate({...elementDate, [e.target.id]:e.target.value })};

        const HandleClearDate = ()=>{
            setElementDate({});
            setOpenMenuDate(null);
            setFilterDate(false);
        };

        const HandleProcessFilterDate = ()=>{
            if(elementDate.Inicio === '' || elementDate.Final === ''){
                if(elementDate.Inicio === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE INICIO REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE FINAL REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }
            }else{
                const resultInicio = new Date(elementDate.Inicio)
                const resultFinal = new Date(elementDate.Final)
                if(elementDate.idElement === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'DEBE SELECCIONAR UNA FILA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{ 
                    if(resultInicio > resultFinal){ 
                        setOpenMenuDate(null);
                        Swal.fire({
                            title:'FECHA DE INICIO DEBE SER MENOR A LA FECHA FINAL',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                            width:'450px'
                        });
                    }else{
                        if(isFilterNow){
                            const arrFil = [];
                            for(const a in rows){
                                const el ={...rows[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }    
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }else{
                            const arrFil = [];
                            for(const a in backupRows){
                                const el ={...backupRows[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }                           
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }
                    }
                }
            }
            
        };

        const HandleResetFilterDate = ()=>{
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setFilterDate(false);
            if(isFilterNow){
                setRows(rowsFilter)
            }else{
                setRows(backupRows);
            }    
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementDate({...elementDate, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementDate({...elementDate, idElement:arrFilHeaders[0].id.toString(), labelElement:value});
                }  
            }
            
        };

        const handleClickRow = useCallback((statusRow, row)=>{
            if(statusRow){
                const arr = [...selectionArr];
                arr.push(row);
                setSelectionArr(arr);
            }else{
                const arr = selectionArr.filter(value=> value._id !== row._id);
                setSelectionArr(arr);
            }
        },[selectionArr]);

        const HandleExportSelectPdf = ()=>{
            if(selectionArr.length === 0){
                setOpenMenuPdf(null);
                Swal.fire({
                    title:'NO HAY ELEMENTOS A EXPORTAR',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else{
                if(isReadyPdf){
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setReadyPdf(false);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }else{
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }
                
            }
        };

        const HandleExportAllPdf = ()=>{
            if(isReadyPdf){
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setReadyPdf(false);
                setSelectPdf(false);
                setContinuoPdf(true);
            }else{
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setSelectPdf(false);
                setContinuoPdf(true);
                
            }
        };

        const HandleClickPdf = useCallback(()=>{
            setTimeout(()=>{
                setReadyPdf(false);
            },2000)
        },[]);

        const handleCloseSelectPersonsMail = ()=>{ setOpenSelectPersonsMail(false); };

        const HandleRemitentes = (e, value)=>{ setRemitentes(value) };

        const HandleSelectPersonsMail = ()=>{
            if(selectionArr.length > 0){
                setOpenSelectPersonsMail(true);
            }else{
                enqueueSnackbar('SELECCIONE UNA FILA POR LO MENOS', {variant:'info'});
            }
        };

        const HandleSendCorreos = ()=>{
            fetch('/SendMailsRows',{ 
                method: 'POST',
                body: JSON.stringify({Elementos:selectionArr, headersColumn, Remitentes}),
                headers:{'Content-Type':'application/json'}
            })
            .then(response=> response.json())
            .then(result =>{
                setOpenSelectPersonsMail(false);
                enqueueSnackbar('Correos Enviados', {variant:'success'});
            });
        };
        
        const HandleProcessHeaders = useCallback((dataHeadersStyle)=>{
            const headersResultStyles = headersColumn.map(value=>{
                if(value.id === dataHeadersStyle.id){
                    return dataHeadersStyle;
                }else{
                    return value;
                }
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setOpenMenuStyles(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        },[headersColumn]);

        const ElementMenuStyles = headersColumn.map((value,index)=>( 
            <Grid item key={`ElementMenuStyles_${index}`} xl={12} lg={12} md={12} sm={12} xs={12} >
                <RowHeadersStyle rowInfo={value} HandleProcessHeaders={HandleProcessHeaders} widthWin={widthWin}/>
            </Grid>
                
        ));

        const handleOpenMenuStyles = ()=>{ setOpenMenuStyles(true) };

        const handleCloseMenuStyles = ()=>{ setOpenMenuStyles(false) };

        const handleHeadersPosicion = (e)=>{
            const idEl = e.target.id.split('_')[0];
            const arr =  headersColumn.map(value=>{
                if(value.id.toString() === idEl.toString()){
                    const objeto = {...value};
                    objeto.num = e.target.value;
                    return objeto;
                }else{
                    return value;
                }
            })
            setHeadersColumn(arr);
        };

        const ElementMenuPosicion = headersColumn.map((value,index)=>( 
            <Grid item style={{width:100}} key={`ElementFixed_${index}`}>
                <TextField 
                    id={`${value.id}_${value.num}`}
                    name={'num'}
                    value={value.num ||''}
                    onChange={handleHeadersPosicion}
                    fullWidth
                    margin='dense'
                    variant='outlined'
                    label={value.label}
                />
            </Grid>
        ));

        const handleClickMenuPosicion = () => { setOpenMenuPosicion(true)};
        
        const handleCloseMenuPosicion = ()=> { setOpenMenuPosicion(false) };

        const handleResetPosicion = ()=>{
            const headersResultStyles = [];
            headersColumn.forEach(value=>{
                headCellsColumn.forEach(value2=>{
                    if(value.id === value2.id){
                        const objeto = {...value};
                        objeto.num = value2.num;
                        headersResultStyles.push(objeto);
                    }
                })
            })
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles));
            setOpenMenuPosicion(false);
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleProcessPosicion = ()=>{
            const headersResultStyles = headersColumn;
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleAddRow = ()=>{ setOpenNew(true) };

        const handleOpenDanado = ()=>{ setOpenDanado(true);};

        const handleCloseDanado = ()=>{setOpenDanado(false);};

        const handleSelectTipo = (e, value, reason)=>{
            if(reason === 'select-option'){
                setReporteDanado({...ReporteDanado, Tipo:value, Marca:'', Modelo:'', Macs:[]})
                const arr1 = backupRows.filter(elRow=> elRow.Tipo === value);
                const arr2 = arr1.map(el=>el.Marca);
                const arr3 = new Set(arr2);
                const arr4  = [...arr3];
                setOnlyMarcas(arr4);
            }else{
                setReporteDanado({...ReporteDanado, Tipo:'', Marca:'', Modelo:'', Macs:[]});
                setOnlyMarcas([]);
                setOnlyModelos([]);
                setOnlyMacs([]);
            }
            
        };

        const handleSelectMarca = (e, value, reason)=>{
            if(reason === 'select-option'){
                setReporteDanado({...ReporteDanado, Marca:value, Modelo:''})
                const arr = backupRows.filter(elRow=> elRow.Tipo === ReporteDanado.Tipo);
                const arr1 = arr.filter(elRow=> elRow.Marca === value);
                const arr2 = arr1.map(el=>el.Modelo);
                const arr3 = new Set(arr2);
                const arr4  = [...arr3];
                setOnlyModelos(arr4);
            }else{
                setReporteDanado({...ReporteDanado, Marca:'', Modelo:''});
                setOnlyModelos([]);
                setOnlyMacs([]);
            }
        };

        const handleSelectModelo = (e, value, reason)=>{
            if(reason === 'select-option'){
                setReporteDanado({...ReporteDanado, Modelo:value});
                const arr_0 = backupRows.filter(elRow=> elRow.Tipo === ReporteDanado.Tipo);
                const arr = arr_0.filter(elRow=> elRow.Marca === ReporteDanado.Marca);
                const arr1 = arr.filter(elRow=> elRow.Modelo === value);
                const arr2 = arr1.map(el=>el.Mac);
                const arr3 = new Set(arr2);
                const arr4  = [...arr3];
                setOnlyMacs(arr4);
                const arr_1 = arr1.filter(elModelo=> elModelo.Status !== 'Disponible');
                const arr_2 = arr_1.map(el=>el.Mac);
                const arr_3 = new Set(arr_2);
                const arr_4  = [...arr_3];
                setOnlyMacsDanadas(arr_4);
            }else{
                setReporteDanado({...ReporteDanado, Modelo:''});
                setOnlyMacs([]);
                setOnlyMacsDanadas([]);
            }
        };
        

        const handleSelectMac = (e, value, reason)=>{ 
            // console.log(value)
            setReporteDanado({...ReporteDanado, Macs:value});
         };

        const handleSelectMacDanado = (e, value, reason)=>{ 
            setReporteDanado((old)=>({...old, Mac:value}))
        };

        const handleSelectStatus = (e, value, reason)=>{
            if(reason === 'select-option'){
                setReporteDanado({...ReporteDanado, StatusAct:value});
            }else{
                setReporteDanado({...ReporteDanado, StatusAct:''});
            }
        };

        const handleResetDanado = ()=>{
            setOnlyMarcas([]);
            setOnlyModelos([]);
            setOnlyMacs([]);
            setOnlyMacsDanadas([]);
            setReporteDanado({Tipo:'', Marca:'', Modelo:'', Macs:[], Observacion:'', StatusAct:''});
            setNumberMac(0);
        };

        const handleValidarDanado = ()=>{
            setOpenDanado(false);
            Swal.fire({
                title: 'LA INFORMACION ES CORRECTA?',
                text:'SI ESTE EQUIPO ESTA ASIGNADO A UN CLIENTE, SE LO ELIMINARÁ',
                icon:'info',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor:'#005596'
            }).then((result) => {
                handleProcesarDanado();
            })
        };

        const handleProcesarDanado = ()=>{
            if( numberMac < ReporteDanado.Macs.length ){
                const elMac = backupRows.find(elRow=>elRow.Mac?.toString() === ReporteDanado.Macs[numberMac].toString());
                const objeto = {
                    ...elMac,
                    StatusAct:ReporteDanado.StatusAct,
                    Observacion:ReporteDanado.Observacion,
                };
                fetch('/api/Stocks/Danado',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        setNumberMac(oldMac=> oldMac + 1 );
                        setContinuoMac(true);
                    }else{
                        Swal.fire({
                            title: result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }
                    
                })
            }else{
                const arrNew = backupRows.map(el=>{
                    if(ReporteDanado.Macs.includes(el.Mac)){
                        const objetoNew = {
                            ...el,
                            Status: ReporteDanado.StatusAct,
                            idForMikrotik: '',
                            idServicio: '',
                            ColNew: false,
                            EditRowNow: false,
                            Observacion: ReporteDanado.Observacion ? ReporteDanado.Observacion : '',
                        }
                        return objetoNew;
                    }else{
                        return el;
                    }
                })
                setRows(arrNew);
                setBackupRows(arrNew);
                setSearch('');
                setReporteDanado({Tipo:'', Marca:'', Modelo:'', Macs:[], StatusAct:'', Observacion:''});
                setNumberMac(0);
                Swal.fire({
                    title: 'COMPLETADO',
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
        }

        const handleOpenActivar = ()=>{
            const arr = backupRows.map(elRow=>elRow.Tipo);
            const arr2 = new Set(arr);
            const arr3  = [...arr2];
            setOnlyTipos(arr3);
            setOpenActivar(true);
        };

        const handleCloseActivar = ()=>{ setOpenActivar(false); };

        const handleValidarActivar = ()=>{
            const objetoNew = {...ReporteDanado};
            objetoNew.StatusAct = 'Disponible';
            objetoNew.Observacion = '';
            setOpenActivar(false);
            Swal.fire({
                title: 'LA INFORMACION ES CORRECTA?',
                icon:'info',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor:'#005596'
            }).then((result_) => {
                fetch('/api/Stocks/Activar',{ 
                    method:'POST', 
                    body: JSON.stringify(objetoNew), 
                    headers:{'Content-Type': 'application/json'}
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        const arrFil = {...rows.filter(elRow=>elRow.Mac?.toString() === ReporteDanado.Mac.toString())[0]};
                        arrFil.Status = 'Disponible';
                        arrFil.idForMikrotik = '';
                        arrFil.idServicio = '';
                        arrFil.ColNew = false;
                        arrFil.EditRowNow = false;
                        arrFil.Observacion = '';
                        const getInfo = backupRows.map(el=>{ 
                            if(el.Mac.toString() === ReporteDanado.Mac.toString() ){ 
                                return arrFil 
                            }else{ 
                                return el
                            }
                        });
                        setRows(getInfo);
                        setBackupRows(getInfo);
                        setSearch('');
                        // dispatch({type:types.stockUpdate, payload:arrFil});
                        setReporteDanado({Tipo:'', Marca:'', Modelo:'', Macs:[], StatusAct:'', Observacion:''})
                        Swal.fire({
                            title: result.message,
                            icon:'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }else{
                        Swal.fire({
                            title: result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }
                    
                })
            })
        };

        const handleTiposNew = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow,Tipo:value, Marca:'', Modelo:'', Mac:'', SN:''});
                const equiFilter = Equipos.filter(elEquipo=> elEquipo.Tipo === value);
                const arrNew = equiFilter.map(elEqui=>elEqui.Marca);
                const newSet = new Set(arrNew);
                const arrSet = [...newSet];
                setOnlyMarcas(arrSet);
            }else{
                setDataRow({...dataRow, Tipo:'', Marca:'', Modelo:'', Mac:'', SN:''});
                setOnlyMarcas([]);
                setOnlyModelos([]);
            }
        };

        const handleMarcasNew = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Marca:value, Modelo:'', Mac:'', SN:''});     
                const tipoFilter = Equipos.filter(elEquipo=> elEquipo.Tipo === dataRow.Tipo);
                const marcasFilter = tipoFilter.filter(elEquipo=> elEquipo.Marca === value);
                const arrNew = marcasFilter.map(elEqui=>elEqui.Modelo);
                const newSet = new Set(arrNew);
                const arrSet = [...newSet];
                setOnlyModelos(arrSet);
            }else{
                setDataRow({...dataRow, Marca:'', Modelo:'', Mac:'', SN:''});
                setOnlyModelos([]);
            }
        };

        const handleModelosNew = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Modelo:value, Mac:'', SN:''});
            }else{
                setDataRow({...dataRow, Modelo:'', Mac:'', SN:''});
            }
        };

        const handleProveedoresNew = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Proveedor:value});
            }else{
                setDataRow({...dataRow, Proveedor:''});
            }
        };

        const handleTecnologiasNew = (e, value, reason)=>{
            if(reason === 'select-option'){
                setDataRow({...dataRow, Tecnologia:value});
            }else{
                setDataRow({...dataRow, Tecnologia:''});
            }
        };

        const handleBridgeNew = (checked)=>{ setDataRow({...dataRow, Bridge:checked}); }

        const handleDatosMacNew = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if( getArrMac.includes(val !== null ? val.join(":") : val)){
                alert('YA EXISTE UNA MAC IGUAL')
            }else{
                if(val.length > 6){
                    enqueueSnackbar('LIMITE DE CARACTERES EXCEDIDO', {variant:"error"});
                }else{
                    setDataRow({...dataRow, Mac:val !== null ? val.join(":") : val });
                }
                
            }
        };

        const handleDatosMac2New = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            if( getArrMac.includes(val !== null ? val.join(":") : val)){
                alert('YA EXISTE UNA MAC IGUAL')
            }else{
                if(val.length > 6){
                    enqueueSnackbar('LIMITE DE CARACTERES EXCEDIDO', {variant:"error"});
                }else{
                    setDataRow({...dataRow, Mac2:val !== null ? val.join(":") : val });
                }
            }
        };
        
        const handleOptionNew = ({target})=>{ setDataRow({...dataRow, [target.name]:target.value}); }

        const handleSaveNew = ()=>{
            setOnSave(true);
            if(dataRow.Mac.length < 17){
                enqueueSnackbar('ERROR MAC', {variant:'error'});
                setOnSave(false);
            }else{
                const objeto = {...dataRow};
                objeto.Empresa = authTokens.Empresa;
                fetch(variablesObject.api,{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                .then(response=> response.json())
                .then(result =>{
                    if(result._id){
                        const objeto = {...dataRow};
                        objeto._id = result._id;
                        setDataRow({
                            Tipo:'', Marca:'', Modelo:'', 
                            Bridge:false, Tecnologia:'', 
                            Mac:'', Mac2:'', Proveedor:'', 
                            SN:'', Status:'Disponible', 
                            idForMikrotik:'', Observacion:'',
                            fechaCompra:'', idForMikrotikBack:'',
                            Danado:false, fechaDanado:'', NumSerie:''
                        });
                        setOnlyMarcas([]);
                        setOnlyModelos([]);
                        const nEl = [...backupRows];
                            nEl.unshift(objeto);
                        setRows(nEl);
                        setBackupRows(nEl);
                        setSearch('');
                        const macArr = nEl.map(el=>el.Mac && el.Mac.toString().trim().toUpperCase());
                        setArrMac(macArr);
                        // dispatch({type:types.stockCreate, payload:objeto});
                        setOnSave(false);
                        enqueueSnackbar('STOCK AGREGADO', {variant:'success'});
                    }else{
                        Swal.fire({
                            title: result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        });
                        setOnSave(false);
                    }
                    
                })
            }
            
        };

        const handleEditRow = useCallback((idEl, valueEl)=>{
            const datRows = backupRows.map(elRow=>{
                if(elRow._id.toString() === idEl.toString()){
                    return valueEl
                }else{
                    return elRow
                }
            })
            setRows(datRows);
            setBackupRows(datRows);
        },[backupRows ]);

        const handleDeleteRow = useCallback((idEl)=>{
            setRows((inf)=>inf.filter(el=>el._id !== idEl));
            setBackupRows((inf)=>inf.filter(el=>el._id !== idEl));
        },[ ]);

        const handleCancelarNew = ()=>{ setOpenNew(false);};

        const handleSelectionAll = ()=>{
            setSelectionArr(rows);
            setRows([]);
            setContinuoUnSelect(true);
        };

        const handleUnSelect = ()=>{
            setSelectionArr();
            setRows([]);
            setSelectionArr([]);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
            setFilterNow(false);
            setFilterDate(false);
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setContinuoUnSelect(true);
        };

        const handleSearch = ({target})=>{
            setSearch(target.value);
            if(target.value === ''){
                setRows(backupRows);
            }else{
                setRows(backupRows.filter(el=>el[getOptionSearch]?.toLowerCase().includes(target.value.toLowerCase())));
            }
        }; 

        const handleClickMenuBusqueda = (event) => {
            setOpenMenuBusqueda(event.currentTarget);};

        const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

        const handleShowBusqueda = ()=>{
            setShowBusqueda(el=>{
                if(el) {
                    setRows(backupRows);
                    setSearch('');
                }
                return !el
            });
        };

        const handleDeleteMultiple = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR TODO(A)S ${variablesObject.title}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed) setDelete(true);
            })
        };

        const handleDeleteElement = ()=>{
            fetch(variablesObject.api,{ method:'DELETE', body: JSON.stringify(selectionArr[getElementD]), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    console.log(`Elemento Posicion${getElementD} Eliminado`);
                    if(getElementD + 1 < selectionArr.length){
                        setElementD(el=> el + 1);
                        setDelete(true);
                    }else if(getElementD + 1 === selectionArr.length){
                        enqueueSnackbar(result.message, {variant:'success'});
                        const arrNew = selectionArr.map(el=> el._id);
                        const arrFiltrado_ = backupRows.filter(el=> !arrNew.includes(el._id));
                        setRows(arrFiltrado_);
                        setBackupRows(arrFiltrado_);
                        setSelectionArr([]);
                        setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
                        setFilterNow(false);
                        setFilterDate(false);
                        setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
                        setSearch('');
                    }
                    
                }else{
                    console.error(result.status);
                    enqueueSnackbar(result.status, {variant:'error'});
                }
            })
        };

        return(
            <Grid 
                container 
                justifyContent='center'
                style={{width:'100%', padding:0, position:'relative', left:0, minHeight:'90vh' }} 
            >
                <Dialog
                    open={openMenuFilter}
                    onClose={handleCloseMenuFilter}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            { isElementFilterShow ? ElementMenuFilter
                            : <FacebookCircularProgress size={25} style={{marginTop:5}}/>}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuFilter} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleResetFilter} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcessFilterElement}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuFilter} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={HandleResetFilter} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={HandleProcessFilterElement} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openMenuStyles}
                    onClose={handleCloseMenuStyles}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuStyles}
                        </Grid>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openMenuPosicion}
                    onClose={handleCloseMenuPosicion}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuPosicion}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuPosicion} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={handleResetPosicion} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={handleProcessPosicion}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuPosicion} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={handleResetPosicion} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={handleProcessPosicion} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openSelectPersonsMail}
                    onClose={handleCloseSelectPersonsMail}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Autocomplete
                            id="Remitentes"
                            freeSolo
                            options={RemitentesAll}
                            value={Remitentes || ''}
                            onChange={HandleRemitentes}
                            multiple
                            renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Remitentes"
                                />
                              )}
                        /> 
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={handleCloseSelectPersonsMail} color="default" style={{height:40}}>
                            CANCELAR
                        </Button>
                        <Button variant='contained' onClick={HandleSendCorreos} color="primary" style={{margin:3, height:40}}>
                            ENVIAR
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openDanado}
                    onClose={handleCloseDanado}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseDanado}>
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                                <Chip color='secondary' label='DAR DE BAJA A EQUIPOS' style={{fontWeight:'bolder'}}/>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="StatusDanado"
                                    fullWidth
                                    options={onlyStatus}
                                    value={ReporteDanado.StatusAct || ''}
                                    onChange={handleSelectStatus}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Nuevo Status"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="TipoDanado"
                                    fullWidth
                                    options={onlyTipos}
                                    value={ReporteDanado.Tipo || ''}
                                    onChange={handleSelectTipo}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Tipo"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="MarcaDanado"
                                    fullWidth
                                    options={onlyMarcas}
                                    value={ReporteDanado.Marca || ''}
                                    onChange={handleSelectMarca}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Marca"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}> 
                                <Autocomplete
                                    id="ModeloDanado"
                                    fullWidth
                                    options={onlyModelos}
                                    value={ReporteDanado.Modelo || ''}
                                    onChange={handleSelectModelo}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Modelo"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    multiple
                                    id="Macs"
                                    options={onlyMacs}
                                    disableCloseOnSelect
                                    value={ReporteDanado.Macs || ''}
                                    onChange={handleSelectMac}
                                    // getOptionLabel={(option) => option.Zona}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                        {option}
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Macs" fullWidth placeholder="Macs" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    id='Observacion'
                                    fullWidth
                                    label='Observacion'
                                    value={ ReporteDanado.Observacion || ''}
                                    onChange={({target})=>{ setReporteDanado({...ReporteDanado, Observacion:target.value})}}  
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    multiline
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                                <Button variant='contained' onClick={handleValidarDanado} color="primary" style={{margin:3, height:40}} startIcon={<SaveIcon />}>
                                    GUARDAR
                                </Button>
                            </Grid>
                            <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                                <Button variant='contained' onClick={handleCloseDanado} color="default" style={{height:40}} startIcon={<CancelIcon />}>
                                    CANCELAR
                                </Button>
                            </Grid>
                            <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                                <Button variant='contained' onClick={handleResetDanado} color="default" style={{height:40}} startIcon={<AutorenewIcon />}>
                                    RESETEAR
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openActivar}
                    onClose={handleCloseActivar}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="TipoDanado"
                                    fullWidth
                                    options={onlyTipos}
                                    value={ReporteDanado.Tipo || ''}
                                    onChange={handleSelectTipo}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Tipo"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="MarcaDanado"
                                    fullWidth
                                    options={onlyMarcas}
                                    value={ReporteDanado.Marca || ''}
                                    onChange={handleSelectMarca}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Marca"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}> 
                                <Autocomplete
                                    id="ModeloDanado"
                                    fullWidth
                                    options={onlyModelos}
                                    value={ReporteDanado.Modelo || ''}
                                    onChange={handleSelectModelo}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Modelo"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="MacDanado"
                                    fullWidth
                                    options={onlyMacsDanadas}
                                    value={ReporteDanado.Mac || ''}
                                    onChange={handleSelectMacDanado}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Mac"
                                        />
                                    )}
                                /> 
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={handleCloseActivar} color="default" style={{height:40}}>
                            CANCELAR
                        </Button>
                        <Button variant='contained' onClick={handleValidarActivar} color="primary" style={{margin:3, height:40}}>
                            ACTIVAR
                        </Button>
                    </DialogActions>
                </Dialog>
                <ModalAntd title="AGREGAR" visible={getOpenNew} onOk={handleSaveNew} onCancel={handleCancelarNew}  confirmLoading={getOnSave}>
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                        <Grid container justifyContent='space-between' spacing={2}> 
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`Tipo_0`}
                                    options={onlyTipos}
                                    value={dataRow.Tipo || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Tipo' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleTiposNew} 
                                    size='small'                                 
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`Marca_0`}
                                    options={onlyMarcas}
                                    value={dataRow.Marca || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Marca' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleMarcasNew} 
                                    size='small'  
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`Modelo_0`}
                                    options={onlyModelos}
                                    value={dataRow.Modelo || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Modelo' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleModelosNew} 
                                    size='small' 
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                     id={`Tecnologias_0`}
                                    options={getTecnologias}
                                    value={dataRow.Tecnologia || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Tecnologia' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleTecnologiasNew} 
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`Mac_0`}
                                    fullWidth
                                    label='Mac'
                                    value={dataRow.Mac || ''}
                                    onChange={handleDatosMacNew}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`Mac2_0`}
                                    fullWidth
                                    label='Mac2'
                                    value={dataRow.Mac2 || ''}
                                    onChange={handleDatosMac2New}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField 
                                    id={`SN_0`}
                                    name='SN'
                                    fullWidth
                                    label='SN'
                                    value={dataRow.SN || ''}
                                    onChange={handleOptionNew}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={4} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <SwitchAntd checkedChildren="BRIDGE" unCheckedChildren="NO BRIDGE" checked={dataRow.Bridge} onChange={handleBridgeNew} /> 
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id={`Proveedor_0`}
                                    options={Proveedores.map(elProv=>elProv.Nombre)}
                                    value={dataRow.Proveedor || ''}                              
                                    renderInput={(params) => <TextField {...params} label='Proveedor' variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleProveedoresNew} 
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField 
                                    id={`fechaCompra_0`}
                                    name='fechaCompra'
                                    fullWidth
                                    label='Fecha Compra'
                                    value={dataRow.fechaCompra || '2022-01-01'}
                                    onChange={handleOptionNew}
                                    variant='outlined'
                                    size='small'
                                    type='date'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    id={`Obs_0`}
                                    name='Observacion'
                                    fullWidth
                                    label='Observacion'
                                    value={dataRow.Observacion || ''}
                                    onChange={handleOptionNew}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    multiline
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </ModalAntd> 
                <Grid 
                    item 
                    xs={12} 
                    style={{ position:'fixed', top:60, left:0, width:'100%', zIndex:20, minHeight:40 }}
                >
                    <Paper 
                        elevation={2} 
                        square 
                        style={{ 
                            alignItems:'center', 
                            display:'flex', 
                            justifyContent:'center', 
                            padding:5, 
                            width:'100%', 
                        }}
                    >
                        <Grid 
                            alignItems='center'
                            container 
                            justifyContent={ widthWin === 'xs' ||  widthWin === 'sm' ? 'center' : 'flex-start'} 
                            spacing={1} 
                        >
                            {
                                widthWin === 'xs' ||  widthWin === 'sm'?
                                <Fragment>
                                    <Grid item  md={3} sm={10} xs={12} style={{ padding:0}}>
                                        {   isShowBusqueda ? 
                                            <Grid 
                                                container 
                                                justifyContent='space-around' 
                                                alignItems='center' 
                                                spacing={0}
                                            >
                                                <Grid item xs={9}>
                                                    <TextField 
                                                        id='SearchOptions'
                                                        fullWidth
                                                        onChange={handleSearch}  
                                                        placeholder={ getOptionSearch || 'Busqueda' }
                                                        size='small'
                                                        value={ getSearch || ''}
                                                        variant='outlined'
                                                        margin='dense'
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                        <span>
                                                        <IconButton 
                                                            color='primary'
                                                            onClick={handleClickMenuBusqueda}  
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            size='small'
                                                        >                            
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-busqueda"
                                                        anchorEl={openMenuBusqueda}
                                                        keepMounted
                                                        open={Boolean(openMenuBusqueda)}
                                                        onClose={handleCloseMenuBusqueda}
                                                    >
                                                        {
                                                            headersColumn.map((el, index)=>
                                                                <MenuItem 
                                                                    key={`${el.id}_${index}_`} 
                                                                    style={{width:'100%'}}
                                                                    onClick={()=>{
                                                                        setOptionSearch(el.id);
                                                                        setOpenMenuBusqueda(null)
                                                                    }}
                                                                >
                                                                    {el.label}
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                style={{ background:'dodgerblue', color:'#fff' }}
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>:
                                            <Grid 
                                                alignItems='center' 
                                                container 
                                                justifyContent='center' 
                                                spacing={2} 
                                                style={{minHeight:68, height:65}}
                                            >
                                                <Grid item>
                                                    <Chip label={variablesObject.title} color='secondary' />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                        <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                            style={{ background:'dodgerblue', color:'#fff' }}
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='VER' placement='top'>
                                            <span>
                                            <IconButton size='small' color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                <VisibilityIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>         
                                        <Menu
                                            id="menu-column"
                                            anchorEl={openMenuColumn}
                                            keepMounted
                                            open={Boolean(openMenuColumn)}
                                            onClose={handleCloseMenu}
                                            >
                                            {ElementMenu}
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FIJAR' placement='top' >
                                                <span>
                                                <IconButton size='small' color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                    <ViewWeekIcon />
                                                </IconButton>
                                                </span>
                                        </Tooltip> 
                                        <Menu
                                            id="menu-column-fixed"
                                            anchorEl={openMenuColumnFixed}
                                            keepMounted
                                            open={Boolean(openMenuColumnFixed)}
                                            onClose={handleCloseMenuFixed}
                                            >
                                            {ElementMenuFixed}
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FILTRAR' placement='top' >
                                            <span>
                                            <IconButton size='small' color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                <FilterListIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='FECHAS' placement='top' >
                                            <span>
                                            <IconButton size='small' color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                <DateRangeIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-column-date"
                                            anchorEl={openMenuDate}
                                            keepMounted
                                            open={Boolean(openMenuDate)}
                                            onClose={handleCloseMenuDate}
                                        >
                                            <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                <Autocomplete
                                                    id={'AutoComplete-ElementDate'}
                                                    options={headersColumn.filter(el=>el.type==='date')}
                                                    getOptionLabel={option => option.label }
                                                    renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                    inputValue={elementDate.labelElement || ''}
                                                    onInputChange={HandleAutoComplete}
                                                    size='small'
                                                    style={{width:'100%'}}
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Inicio'}>
                                                <TextField 
                                                    id='Inicio'
                                                    value={elementDate.Inicio || new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Inicio'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Final'}>
                                                <TextField 
                                                    id='Final'
                                                    value={elementDate.Final ||  new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Final'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Process'}>
                                                <Grid container justifyContent='center'>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="default" size='small' onClick={HandleClearDate} >
                                                            <ClearIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                            <AutorenewIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                            <NavigateNextIcon />
                                                        </Fab>
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        </Menu>   
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='EXPORT PDF' placement='top'>
                                                <span>
                                                <IconButton size='small' aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                                </span>
                                        </Tooltip>  
                                        <Menu
                                            id="menu-pdf"
                                            anchorEl={openMenuPdf}
                                            keepMounted
                                            open={Boolean(openMenuPdf)}
                                            onClose={handleCloseMenuPdf}
                                        >
                                            <MenuItem onClick={HandleExportSelectPdf} >
                                                Export Select
                                            </MenuItem>
                                            <MenuItem onClick={HandleExportAllPdf} >
                                                Export All
                                            </MenuItem>
                                            <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                {
                                                    isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : backupRows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                    : '...'
                                                }
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='EXPORT EXCEL' placement='top'>
                                            <span>
                                            <IconButton size='small' aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                <DescriptionIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-excel"
                                            anchorEl={openMenuExcel}
                                            keepMounted
                                            open={Boolean(openMenuExcel)}
                                            onClose={handleCloseMenuExcel}
                                        >
                                            <MenuItem >
                                                {
                                                    selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                        Swal.fire({
                                                            title:'NO HAY ELEMENTOS A EXPORTAR',
                                                            toast:true,
                                                            confirmButtonColor:'#0E3B5F',
                                                        });}}>Export Select</span>
                                                    :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                }
                                            </MenuItem>
                                            <MenuItem >
                                                <ExcelComponent data={backupRows} titulo={'Export All'} headersColumn={headersColumn} />
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='CORREOS' placement='top'>
                                            <span>
                                            <IconButton size='small' color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                <MarkunreadMailboxIcon/>
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='ESTILOS' placement='top'>
                                            <span>
                                                <IconButton size='small' style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                    <BrushIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>  
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='POSICION' placement='top'>
                                            <span>
                                            <IconButton size='small' style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                <BorderVerticalIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='ADD ROW' placement='top'>
                                            <span>
                                                <IconButton size='small' style={{marginRight:2}} onClick={handleAddRow} color='primary'>
                                                    <PlusOneIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='DAR DE BAJA A EQUIPOS' placement='top'>
                                            <span>
                                                <IconButton size='small' style={{marginRight:2}} onClick={handleOpenDanado} color='primary'>
                                                    <RestoreFromTrashIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='ACTIVAR EQUIPO' placement='top'>
                                            <span>
                                                <IconButton size='small' style={{marginRight:2}} onClick={handleOpenActivar} color='primary'>
                                                    <OfflinePinIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='SELECT ALL' placement='top'>
                                            <span>
                                            <IconButton style={{position:'relative',  left:-4}} onClick={handleSelectionAll} color='primary'>
                                                <CheckBoxIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    {
                                        selectionArr.length > 0 &&
                                        <React.Fragment>
                                            <Grid item xs={1}>
                                                <Tooltip title='DELETE ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{position:'relative',  left:-4}} onClick={handleDeleteMultiple} color='primary' >
                                                        <DeleteIcon style={{color:'red'}}/>
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Tooltip title='UNSELECT ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{position:'relative',  left:-4}} onClick={handleUnSelect} color='secondary' >
                                                        <CheckBoxOutlineBlankIcon /> 
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </Fragment> :
                                <Fragment>
                                    <Grid item  lg={3} md={4} sm={10} xs={12}>
                                        {   isShowBusqueda ? 
                                            <Grid container justifyContent='space-between' alignItems='center' spacing={0}>
                                                <Grid item xs={9}>
                                                    <TextField 
                                                        id='SearchOptions'
                                                        fullWidth
                                                        label='Busqueda'
                                                        onChange={handleSearch}  
                                                        placeholder={ getOptionSearch || '' }
                                                        size='small'
                                                        value={ getSearch || ''}
                                                        variant='outlined'
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                        <span>
                                                        <IconButton 
                                                            color='primary' 
                                                            onClick={handleClickMenuBusqueda}  
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            size='small'
                                                        >                            
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-busqueda"
                                                        anchorEl={openMenuBusqueda}
                                                        keepMounted
                                                        open={Boolean(openMenuBusqueda)}
                                                        onClose={handleCloseMenuBusqueda}
                                                    >
                                                        {
                                                            headersColumn.map((el, index)=>
                                                                <MenuItem 
                                                                    key={`${el.id}_${index}_`} 
                                                                    style={{width:'100%'}}
                                                                    onClick={()=>{
                                                                        setOptionSearch(el.id);
                                                                        setOpenMenuBusqueda(null)
                                                                    }}
                                                                >
                                                                    {el.label}
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                style={{ background:'dodgerblue', color:'#fff' }}
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>:
                                            <Grid container justifyContent='center' alignItems='center' >
                                                <Grid item>
                                                    <Chip label={variablesObject.title} color='secondary' />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='VER' placement='top'>
                                            <span>
                                            <IconButton color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                <VisibilityIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>         
                                        <Menu
                                            id="menu-column"
                                            anchorEl={openMenuColumn}
                                            keepMounted
                                            open={Boolean(openMenuColumn)}
                                            onClose={handleCloseMenu}
                                            >
                                            {ElementMenu}
                                        </Menu>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='FIJAR' placement='top' >
                                                <span>
                                                <IconButton color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                    <ViewWeekIcon />
                                                </IconButton>
                                                </span>
                                        </Tooltip> 
                                        <Menu
                                            id="menu-column-fixed"
                                            anchorEl={openMenuColumnFixed}
                                            keepMounted
                                            open={Boolean(openMenuColumnFixed)}
                                            onClose={handleCloseMenuFixed}
                                            >
                                            {ElementMenuFixed}
                                        </Menu>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='FILTRAR' placement='top' >
                                            <span>
                                            <IconButton color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                <FilterListIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title='FECHAS' placement='top' >
                                            <span>
                                            <IconButton color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                <DateRangeIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-column-date"
                                            anchorEl={openMenuDate}
                                            keepMounted
                                            open={Boolean(openMenuDate)}
                                            onClose={handleCloseMenuDate}
                                        >
                                            <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                <Autocomplete
                                                    id={'AutoComplete-ElementDate'}
                                                    options={headersColumn.filter(el=>el.type==='date')}
                                                    getOptionLabel={option => option.label }
                                                    renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                    inputValue={elementDate.labelElement || ''}
                                                    onInputChange={HandleAutoComplete}
                                                    size='small'
                                                    style={{width:'100%'}}
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Inicio'}>
                                                <TextField 
                                                    id='Inicio'
                                                    value={elementDate.Inicio || new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Inicio'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Final'}>
                                                <TextField 
                                                    id='Final'
                                                    value={elementDate.Final ||  new Date()}
                                                    onChange={HandleMenuDate}
                                                    fullWidth
                                                    margin='dense'
                                                    type='date'
                                                    label='Final'
                                                    autoFocus
                                                />
                                            </MenuItem>
                                            <MenuItem key={'ElementMenuDate-Process'}>
                                                <Grid container justifyContent='center'>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="default" size='small' onClick={HandleClearDate} >
                                                            <ClearIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                            <AutorenewIcon />
                                                        </Fab>
                                                    </Grid>
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                            <NavigateNextIcon />
                                                        </Fab>
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                        </Menu>   
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='EXPORT PDF' placement='top'>
                                                <span>
                                                <IconButton aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                                </span>
                                        </Tooltip>  
                                        <Menu
                                            id="menu-pdf"
                                            anchorEl={openMenuPdf}
                                            keepMounted
                                            open={Boolean(openMenuPdf)}
                                            onClose={handleCloseMenuPdf}
                                        >
                                            <MenuItem onClick={HandleExportSelectPdf} >
                                                Export Select
                                            </MenuItem>
                                            <MenuItem onClick={HandleExportAllPdf} >
                                                Export All
                                            </MenuItem>
                                            <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                {
                                                    isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : backupRows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                    : '...'
                                                }
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='EXPORT EXCEL' placement='top'>
                                            <span>
                                            <IconButton aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                <DescriptionIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Menu
                                            id="menu-excel"
                                            anchorEl={openMenuExcel}
                                            keepMounted
                                            open={Boolean(openMenuExcel)}
                                            onClose={handleCloseMenuExcel}
                                        >
                                            <MenuItem >
                                                {
                                                    selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                        Swal.fire({
                                                            title:'NO HAY ELEMENTOS A EXPORTAR',
                                                            toast:true,
                                                            confirmButtonColor:'#0E3B5F',
                                                        });}}>Export Select</span>
                                                    :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                }
                                            </MenuItem>
                                            <MenuItem >
                                                <ExcelComponent data={backupRows} titulo={'Export All'} headersColumn={headersColumn} />
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='CORREOS' placement='top'>
                                            <span>
                                            <IconButton color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                <MarkunreadMailboxIcon/>
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='ESTILOS' placement='top'>
                                                <span>
                                                <IconButton style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                    <BrushIcon />
                                                </IconButton>
                                                </span>
                                        </Tooltip>  
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='POSICION' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                <BorderVerticalIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='ADD ROW' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleAddRow} color='primary'>
                                                <PlusOneIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='DAR DE BAJA A EQUIPOS' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleOpenDanado} color='primary'>
                                                <RestoreFromTrashIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip title='ACTIVAR EQUIPO' placement='top'>
                                            <span>
                                            <IconButton style={{marginRight:2}} onClick={handleOpenActivar} color='primary'>
                                                <OfflinePinIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='SELECT ALL' placement='top'>
                                            <span>
                                            <IconButton style={{position:'relative',  left:-4}} onClick={handleSelectionAll} color='primary'>
                                                <CheckBoxIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    {
                                        selectionArr.length > 0 &&
                                        <React.Fragment>
                                            <Grid item >
                                                <Tooltip title='DELETE ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleDeleteMultiple} color='primary' >
                                                        <DeleteIcon style={{color:'red'}}/>
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item >
                                                <Tooltip title='UNSELECT ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleUnSelect} color='secondary' >
                                                        <CheckBoxOutlineBlankIcon /> 
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </Fragment>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid 
                    item 
                    xs={12} 
                    style={{marginTop:widthWin === 'xs' ? 109.5 : 59}}
                >
                    <Paper 
                        square 
                        style={{
                            minHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '82vh' : '74vh',  
                            maxHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '82vh' : '74vh', 
                            width:widthWin === 'xs' ? '100%' : widthWin === 'sm' ? '100%' : variablesObject.sumWidth,
                        }}
                    >
                        { isSavingHeaders ? 
                        <Grid container>
                            <Grid item xs={12} style={{height:'100%', display:'flex', justifyContent:'center', marginTop:'33vh'}}  >                                                                                                                                                                                                                  
                                <FacebookCircularProgress size={40} style={{alignSelf:'center'}}/>
                            </Grid>
                        </Grid>
                        :
                        <Fragment>
                        {isCharging && <LinearProgress color='secondary' />}
                        <TableContainerYounet 
                            maxHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '78vh' : '63vh'} 
                            minHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '78vh' : '63vh'}
                            width={widthWin === 'xl' ? `${variablesObject.sumWidth}px` : widthWin === 'lg' ? `${variablesObject.sumWidth}px` : '100%'}
                        >
                            <TableYounet>
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                    headCells={headersColumn}
                                />               
                                <TableBody>
                                    {stableSort( rows, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            return (
                                                <Roow 
                                                    key={row._id} 
                                                    row={row} 
                                                    index={index} 
                                                    headCells={headersColumn} 
                                                    handleClickRow={handleClickRow}
                                                    // dispatch={dispatch}
                                                    onlyTipos={onlyTipos}
                                                    Equipos={Equipos}
                                                    Proveedores={Proveedores}
                                                    getArrMac={getArrMac}
                                                    enqueueSnackbar={enqueueSnackbar}
                                                    getTecnologias={getTecnologias}
                                                    selectionArr={selectionArr}
                                                    handleEditRow={handleEditRow}
                                                    handleDeleteRow={handleDeleteRow}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </TableYounet>
                        </TableContainerYounet>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage='Filas'
                            style={{
                                alignItems:'center',
                                display:'flex', 
                                flexWrap:'no-wrap',
                                height:40, border:'1px solid gainsboro',
                                justifyContent:widthWin === 'xs' ? 'flex-start' : widthWin === 'sm' ? 'flex-start' : 'flex-end' , 
                                minHeight:40,
                                marginTop:4,
                                overflowY:'hidden',
                                paddingRight:widthWin === 'md' ? 75 : 0,
                                width:widthWin === 'xs' ? '100%' : widthWin === 'sm' ? '100%' : variablesObject.sumWidth,
                            }}
                        />
                        </Fragment>
                        }
                    </Paper>
                </Grid>
            </Grid>  
        )
    };

    function Elementos(props) {
        return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom',horizontal: 'center'}}>
            <Elemento widthWin={props.width}/>
        </SnackbarProvider>
    );
    };

    export default withWidth()(Elementos);